"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Anchor_exports = {};
__export(Anchor_exports, {
  Anchor: () => Anchor
});
module.exports = __toCommonJS(Anchor_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_core = require("@tamagui/core");
var import_text = require("@tamagui/text");
var import_react = require("react");
var import_react_native = require("react-native");
const AnchorFrame = (0, import_core.styled)(import_text.SizableText, {
  name: "Anchor",
  tag: "a",
  accessibilityRole: "link"
});
const Anchor = AnchorFrame.extractable(
  (0, import_react.forwardRef)(({ href, target, ...props }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      AnchorFrame,
      {
        ...props,
        ...import_core.isWeb ? {
          href,
          target
        } : {
          onPress: (event) => {
            var _a;
            (_a = props.onPress) == null ? void 0 : _a.call(props, event);
            if (href !== void 0) {
              import_react_native.Linking.openURL(href);
            }
          }
        },
        ref
      }
    );
  })
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Anchor
});
//# sourceMappingURL=Anchor.js.map
